import { ObservableArray, View } from "binder"
import { AccountSelectorViewModel, singleAccount } from "./accountSelector-viewModel"

export class AccountSelectorView extends View<AccountSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-2992369C-55C2-4AD8-9C00-11B6A67DE467"
    }
    loadHtml(): string {
        let element = require('./accountSelector.html').default;
        let style = require('./accountSelector.less');
        return element;
    }
    constructor() {
       super();
    }

    public set accounts(v: ObservableArray<singleAccount>) { this._accounts = v; } public get accounts(): ObservableArray<singleAccount> { return this._accounts;} private _accounts: ObservableArray<singleAccount>;
    public set selectedAccount(v: singleAccount) { this._selectedAccount = v; } public get selectedAccount(): singleAccount { return this._selectedAccount;} private _selectedAccount: singleAccount;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set selectedAccountName(v: string) { this._selectedAccountName = v; } public get selectedAccountName(): string { return this._selectedAccountName;} private _selectedAccountName: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;

    requestRefresh(){
        this.dataContext.requestRefresh();
    }
}
